import React, { useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import Select from 'react-select';
import InputMask from 'react-input-mask';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { customStyle } from 'helper';
import AddressRemove from 'modules/common/address/AddressRemove';
import * as actions from '../../../action';
import * as c from '../../../constant';

function LandReference({
  getPostedLandApplication,
  getPostedBuildingApplication,
  getBarangayList,
  barangayList,
  getDistrictList,
  districtList,
  formData,
  setFormData,
  setSelectedIndex,
  validateForm,
}) {
  const barangayOptions = barangayList.map((x) => ({
    label: _.get(x, 'attributes.name'),
    value: x.id,
    id: x.id,
  }));

  const districtOptions = districtList.map((x) => ({
    label: _.get(x, 'attributes.name'),
    value: x.id,
    id: x.id,
  }));

  const handleOnSearchLand = () => {
    getPostedLandApplication(formData.tdn, {}, (landData) => {
      setFormData({
        ...formData,
        land_application_id: landData?.data?.id,
        land_owner_name: landData?.data?.attributes?.rptax_owner_name,
        land_owner_pin: landData?.data?.attributes?.pin,
        property_barangay_id: landData?.data?.attributes?.property_barangay_id,
        property_district_id: landData?.data?.attributes?.property_district_id,
        building_application_pin: '',
      });
    });
  };

  const handleOnSearchBuilding = () => {
    getPostedBuildingApplication(formData.tdn, {}, (res) => {
      setFormData({
        ...formData,
        rptax_building_owner_id: res?.data?.included?.buildingOwner?.id,
        building_owner_name:
          res?.data?.included?.buildingOwner?.attributes?.full_name,
        building_application_pin: res?.data?.attributes?.pin,
        building_application_id: res?.data?.id,
        property_barangay_id: `${res?.data?.attributes?.property_barangay_id}`,
        property_district_id: `${res?.data?.attributes?.property_district_id}`,
        land_application_id: res?.data?.attributes?.rptax_land_application_id,
      });
      getBarangayList({
        rptax_district_id: res?.data?.attributes?.property_district_id,
      });
    });
  };

  const onChange = (e) => {
    if (
      (e.target.name === 'machine_location' && e.target.value === 'BUILDING') ||
      e.target.value === 'LAND'
    ) {
      return setFormData({
        ...formData,
        tdn: '',
        rptax_building_owner_id: '',
        building_owner_name: '',
        building_application_pin: '',
        building_application_id: '',
        property_barangay_id: '',
        property_district_id: '',
        land_application_id: '',
        land_owner_pin: '',
        property_street: '',
        land_owner_name: '',
        [e.target.name]: e.target.value,
      });
    }
    return setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const onChangeTaxPayerAddress = (e) => {
    setFormData({
      ...formData,
      property_region_id: e.target.value.region_code,
      property_province_id: e.target.value.province_code,
    });
  };

  useEffect(() => {
    getDistrictList({
      province_id: 65,
    });
  }, []);

  useEffect(() => {
    if (
      formData?.property_district_id !== '' &&
      formData?.property_district_id !== null &&
      formData?.property_district_id !== undefined
    ) {
      getBarangayList({
        rptax_district_id: formData?.property_district_id,
      });
    }
  }, [formData?.property_district_id]);

  useEffect(() => {
    validateForm.validate();
  }, [Object.values(formData).join(',')]);

  return (
    <>
      <div className="row px-3 mb-2">
        <div
          className="col-12 d-flex align-items-center rounded-lg p-3"
          style={{
            border: '1px dashed #64A5FF',
            backgroundColor: '#ECF4FF',
          }}
        >
          <div className="form-check form-check-inline">
            <input
              type="radio"
              name="machine_location"
              onChange={onChange}
              checked={_.get(formData, 'machine_location') === 'LAND'}
              value="LAND"
            />
            <label
              className="form-check-label business-activity-label ml-3"
              htmlFor="inlineCheckbox1"
            >
              Land
            </label>
          </div>
          <div className="form-check form-check-inline">
            <input
              type="radio"
              name="machine_location"
              onChange={onChange}
              checked={_.get(formData, 'machine_location') === 'BUILDING'}
              value="BUILDING"
            />
            <label
              className="form-check-label business-activity-label ml-3"
              htmlFor="inlineCheckbox1"
            >
              Building
            </label>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-12 mb-2">
          <div className="header-modal">Land Reference</div>
        </div>
        <div className="col-6 form-group">
          <label htmlFor="last_name" className="form-label mb-0">
            TDN/ARP No.
            {validateForm.renderMessage('tdn')}
          </label>
          <div
            className="input-group mb-3 col-12 mt-2"
            style={{ marginLeft: -15 }}
          >
            <InputMask
              className="form-control"
              mask="aa-99999-99999"
              alwaysShowMask
              type="text"
              name="tdn"
              onChange={onChange}
              value={_.get(formData, 'tdn')}
            />
            <div className="input-group-append">
              <button
                disabled={
                  _.get(formData, 'tdn') === '__-_____-_____' ||
                  _.get(formData, 'tdn') === ''
                }
                type="button"
                onClick={() =>
                  _.get(formData, 'machine_location') === 'LAND'
                    ? handleOnSearchLand()
                    : handleOnSearchBuilding()
                }
                className="btn btn-link button-search cms-bg-color-secondary cms-outline-secondary"
              >
                <span className="icon">
                  <i className="fa fa-lg fa-search" />
                </span>
              </button>
            </div>
          </div>
        </div>
        <div className="col-6 form-group" />
        <div className="col-6 form-group">
          <label htmlFor="land_owner_name" className="form-label mb-0">
            Owner
          </label>
          <input
            className="form-control text-uppercase"
            type="text"
            readOnly
            name="land_owner_name"
            onChange={onChange}
            value={_.get(formData, 'land_owner_name') || ''}
          />
        </div>
        <div className="col-6 form-group">
          <label htmlFor="land_owner_pin" className="form-label mb-0">
            PIN.
          </label>
          <input
            className="form-control text-uppercase"
            type="text"
            readOnly
            name="land_owner_pin"
            onChange={onChange}
            value={_.get(formData, 'land_owner_pin') || ''}
          />
        </div>
        <div className="col-6 form-group">
          <label className="form-label">Building Owner</label>
          <div>
            <input
              className="form-control text-uppercase"
              type="text"
              readOnly
              name="building_owner_name"
              onChange={onChange}
              value={_.get(formData, 'building_owner_name') || ''}
            />
          </div>
        </div>
        <div className="col-6 form-group mt-2">
          <label htmlFor="building_application_pin" className="form-label mb-0">
            PIN.
          </label>
          <input
            className="form-control text-uppercase"
            type="text"
            readOnly
            name="building_application_pin"
            onChange={onChange}
            value={_.get(formData, 'building_application_pin') || ''}
          />
        </div>
        <div className="col-12 mb-2">
          <div className="header-modal">Property Location</div>
        </div>
        <div className="col-12 form-group">
          <AddressRemove
            required
            value={{
              region_code: _.get(formData, 'property_region_id') || '',
              province_code: _.get(formData, 'property_province_id') || '',
            }}
            onChange={onChangeTaxPayerAddress}
            region_name="property_region_id"
            province_name="property_province_id"
            name="tax_payer_address"
            withStreet={false}
            removeLabel
            isDisabled
          />
        </div>
        <div className="col-6 form-group">
          <label htmlFor="property_district_id" className="form-label mb-0">
            District
          </label>
          <Select
            options={districtOptions}
            isDisabled
            styles={customStyle}
            placeholder="Select District"
            value={
              districtOptions.filter(
                (item) =>
                  +_.get(formData, 'property_district_id') ===
                  +_.get(item, 'id')
              ) || ''
            }
            onChange={() => {}}
          />
        </div>
        <div className="col-6 form-group">
          <label htmlFor="property_barangay_id" className="form-label mb-0">
            Barangay
          </label>
          <Select
            isDisabled
            options={barangayOptions}
            styles={customStyle}
            placeholder="Select Barangay"
            value={
              barangayOptions.filter(
                (item) =>
                  +_.get(formData, 'property_barangay_id') ===
                  +_.get(item, 'id')
              ) || ''
            }
            onChange={() => {}}
          />
        </div>
        <div className="col-12 form-group">
          <label htmlFor="property_street" className="form-label mb-0">
            Unit No. / House No. / Street Name{' '}
            {validateForm.renderMessage('property_street')}
          </label>
          <input
            className="form-control text-uppercase"
            type="text"
            name="property_street"
            onChange={onChange}
            value={_.get(formData, 'property_street') || ''}
          />
        </div>
      </div>
      <hr className="below-hr" />
      <div className="py-1">
        <div className="col-12 d-flex justify-content-center mt-3">
          <button
            type="button"
            onClick={() => setSelectedIndex(1)}
            className="btn btn-light button-cancel-2 mr-1"
            style={{ backgroundColor: '#323943', color: '#fff' }}
          >
            Back
          </button>
          <button
            type="submit"
            className="btn btn-light button-proceed ml-1 cms-bg-color-primary text-light"
            disabled={!validateForm.response.is_passed}
          >
            Proceed
          </button>
        </div>
      </div>
    </>
  );
}

LandReference.defaultProps = {};

LandReference.propTypes = {
  getPostedLandApplication: PropTypes.instanceOf(Function).isRequired,
  getPostedBuildingApplication: PropTypes.instanceOf(Function).isRequired,
  getBarangayList: PropTypes.instanceOf(Function).isRequired,
  barangayList: PropTypes.instanceOf(Array).isRequired,
  getDistrictList: PropTypes.instanceOf(Function).isRequired,
  districtList: PropTypes.instanceOf(Array).isRequired,
  formData: PropTypes.instanceOf(Object).isRequired,
  setFormData: PropTypes.instanceOf(Function).isRequired,
  setSelectedIndex: PropTypes.instanceOf(Function).isRequired,
  validateForm: PropTypes.instanceOf(Object).isRequired,
};

const mapStateToProps = ({ api }) => ({
  barangayList: _.get(api, `${c.GET_BARANGAYS}.list`) || [],
  districtList: _.get(api, `${c.GET_DISTRICTS_LIST}.list`) || [],
});

const enhance = _.flowRight([
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(LandReference);
